var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modelLoaded)?_c('Container',[_c('Row',[_c('Column',[_c('BlockComponentSelector',{attrs:{"model":_vm.model}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }